/**
 * Created by Jerker Nord on 2024-08-26.
 */
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";

export class IceIceYetiToggleWinNumber extends PIXI.Container {

    private _amountText: PIXI.BitmapText;
    private _waysText: PIXI.Text;
    private _isUsed: boolean = false;

    private static WAYS_TEXT_POSITION: PIXI.Point = new PIXI.Point(0, 10);

    public static TOGGLE_WIN_STYLE: BitmapTextStyleOptions = {
        font: {
            name: "yetiCountUp",
            size: 26
        },
        align: "center",
        tint: 0xffffff
    };
    private static WAYS_TEXT_STYLE: PIXI.TextStyle = new PIXI.TextStyle(
        {
            dropShadow: true,
            dropShadowAngle: 1.4,
            dropShadowBlur: 3,
            dropShadowDistance: 1,
            fill: [
                "#fdf451",
                "#f4b940"
            ],
            fontFamily: OpenSans.FAMILY,
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: FontWeight.NORMAL,
            stroke: "#ffed7a",
            strokeThickness: 1
        }
    );

    constructor() {
        super();

        this.init();
    }

    private init(): void {
        this._amountText = new PIXI.BitmapText("0000000", {
            fontName: IceIceYetiToggleWinNumber.TOGGLE_WIN_STYLE.font.name!,
            fontSize: IceIceYetiToggleWinNumber.TOGGLE_WIN_STYLE.font.size,
            align: IceIceYetiToggleWinNumber.TOGGLE_WIN_STYLE.align,
            tint: IceIceYetiToggleWinNumber.TOGGLE_WIN_STYLE.tint
        });
        this._amountText.anchor = 0.5;
        this._amountText.position.y -= 10;
        this.addChild(this._amountText);

        this._waysText = new PIXI.Text("", IceIceYetiToggleWinNumber.WAYS_TEXT_STYLE);
        this._waysText.resolution *= 2;
        this._waysText.anchor.set(0.5, 0.5);
        this._waysText.position = IceIceYetiToggleWinNumber.WAYS_TEXT_POSITION;
        this.addChild(this._waysText);
    }

    public setAmount(amount: number): void {
        this._amountText.text = Currency.formatValue(amount);
    }

    public setWays(ways: number): void {
        const waysText: string = (ways === 1 ? "Way Won" : "Ways Won");
        this._waysText.text = ways + " " + Translation.translate(waysText);
    }

    get isUsed(): boolean {
        return this._isUsed;
    }

    set isUsed(value: boolean) {
        this._isUsed = value;
    }

    public reset(): void {
        this.isUsed = false;
    }
}